module.exports = __webpack_public_path__ + "9e550f5496506d5d59641cc2dfdb2990.svg";